import { render } from "./HomeKr.vue?vue&type=template&id=6930962e&scoped=true"
import script from "./HomeKr.vue?vue&type=script&lang=js"
export * from "./HomeKr.vue?vue&type=script&lang=js"

import "./HomeKr.vue?vue&type=style&index=0&id=6930962e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6930962e"]])

export default __exports__